import { Checkbox, TableCell, TableRow, Typography } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { Test } from "../../graphql/baseTypes";

type TestKeys = keyof Test;

interface Props {
  item: Test;
  isItemSelected?: boolean;
  labelId: string;
  onClickItem: (id: string) => any;

  handleClick: (event: React.MouseEvent<unknown>, name: string) => any;
  columns: Array<{
    id: TestKeys;
    align?: "inherit" | "left" | "center" | "right" | "justify";
  }>;
}

const TestTableItem: React.FC<Props> = ({
  item,
  columns,
  handleClick,
  isItemSelected,
  labelId,
  onClickItem,
}) => {
  const KEY = `${item.locationId}#${item.testId}#${item.date}`;

  const _handleClick = () => {
    onClickItem(KEY);
  };
  return (
    <TableRow
      hover
      onClick={_handleClick}
      role="checkbox"
      tabIndex={-1}
      style={{
        cursor: "pointer",
      }}
      key={KEY}
    >
      <TableCell padding="checkbox">
        <Checkbox
          checked={isItemSelected}
          onClick={(event) => {
            handleClick(event, KEY);
            event.stopPropagation();
          }}
          inputProps={{ "aria-labelledby": labelId }}
        />
      </TableCell>
      {columns.map((column) => {
        if (column.id === "company" || column.id === "location") {
          const { name } = item[column.id];

          return (
            <TableCell key={column.id} align={column.align}>
              <Typography variant="body2">{name}</Typography>
            </TableCell>
          );
        } else if (column.id === "patient") {
          const { firstname, lastname } = item[column.id];

          return (
            <TableCell key={column.id} align={column.align}>
              <Typography variant="body2">
                {firstname} {lastname}
              </Typography>
            </TableCell>
          );
        }
        const value = item[column.id];

        return (
          <TableCell key={column.id} align={column.align}>
            <Typography variant="body2">
              {column.id === "date"
                ? moment(value as string).format("LLL")
                : value}
            </Typography>
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default React.memo(TestTableItem);
